import {Body2} from '@ui/atoms/typography';
import styled from 'styled-components';

const StepsNav = styled.nav`
  @media (max-width: 767px) {
    width: 100%;
    min-width: 0;
    gap: 4px;
  }
`;

const StepItem = styled.div`
  @media (max-width: 767px) {
    min-width: 0;
    flex: 1;
  }
`;

const StepConnector = styled.span`
  @media (max-width: 767px) {
    display: none;
  }
`;

const StepButton = styled.button`
  @media (max-width: 767px) {
    width: 100%;
    min-width: 0;
    padding-right: 4px;
    padding-left: 4px;
  }
`;

interface WizardStepsProps {
  steps: string[];
  activeStep: number;
  onChange?: (step: number) => void;
}

export const WizardSteps = ({
  steps,
  activeStep,
  onChange,
}: WizardStepsProps) => (
  <div className="overflow-x-auto border-b border-borderLight bg-backgroundLight px-4 py-4">
    <StepsNav
      aria-label="Create check-in cycle progress"
      className="mx-auto flex min-w-[680px] items-center justify-center">
      {steps.map((step, index) => {
        const stepNumber = index + 1;
        const isComplete = activeStep > stepNumber;
        const isActive = activeStep === stepNumber;

        return (
          <StepItem className="flex items-center" key={step}>
            {index > 0 && (
              <StepConnector
                aria-hidden="true"
                className={`h-px w-10 ${
                  activeStep > stepNumber ? 'bg-green300' : 'bg-borderDark'
                }`}
              />
            )}
            <StepButton
              type="button"
              aria-current={isActive ? 'step' : undefined}
              disabled={!isComplete || !onChange}
              onClick={() => onChange?.(stepNumber)}
              className={`flex h-[34px] w-[140px] items-center justify-center rounded-[20px] border px-4 py-1.5 text-center transition-colors focus:outline-none focus:ring-2 focus:ring-purple200 ${
                isComplete
                  ? 'border-green300 bg-backgroundLight'
                  : isActive
                  ? 'border-borderDark bg-white shadow-[0px_2px_5px_rgba(172,172,190,0.24)]'
                  : 'border-borderDark bg-backgroundLight'
              }`}>
              <Body2
                className="leading-[22px]"
                kind={
                  isComplete ? 'green300' : isActive ? 'blackTwo' : 'textBody'
                }
                weight={
                  isActive ? 'bold' : isComplete ? 'semibold' : 'regular'
                }>
                {step}
              </Body2>
            </StepButton>
          </StepItem>
        );
      })}
    </StepsNav>
  </div>
);
